module.exports = __webpack_public_path__ + "img/about.36198065.jpg";